/**
 * messages.js
 *
 * ダッシュボードが画面に出すユーザー向け文言。
 * 同じ意味の文言が画面ごとに散らばらないよう、タブ単位でまとめてここに置く。
 * 値の組み立てにロジックが要るもの（サーバ応答と混ぜる等）は utils 側に置く。
 * 文言に埋め込む固定の表示名（「なし」など）も、文言と一緒に直せるようここに置く。
 */

// 「成果物なし」の表示名。判定は成果物の no_deliverable フラグで行い、
// この文字列は画面に出す名前としてのみ使う。
// バックエンドの dashboard/models/transaction_deliverable_management.py と同じ値。
export const NO_DELIVERABLE_LABEL = 'なし';

// 「成果物なし」と同じ意味で書かれる表記ゆれ。人が手で入れる項目なので
// ひらがな・漢字・カタカナが混ざる。半角カナ (ﾅｼ) は NFKC 正規化で ナシ になる。
// 1つでも取りこぼすと、見た目は「なし」なのにフラグが立っていないレコードができ、
// 併存禁止も重複判定もすり抜ける。
export const NO_DELIVERABLE_ALIASES = ['なし', '無し', 'ナシ'];

// 成果物管理タブ
export const DELIVERABLE_MESSAGES = {
  // 「なし」はフラグが持つ予約語。テキストで登録されると、見た目が同じで
  // フラグだけ違うレコードができ、併存禁止も重複判定もすり抜ける。
  RESERVED_PRODUCT_NAME: (product) => (
    `「${product}」は成果物が無いことを表す予約語です。`
    + '「成果物なし」ボタンで設定してください'
  ),

  REQUIRED_FIELDS:
    '必須項目が未入力です。OEM×対地・カテゴリ・大項目・中項目・小項目は'
    + '進捗管理に存在する組み合わせを選択してください。',

  // 座標を選んでいても領域チェックが無ければ進捗管理へのリンクは作られず、
  // カテゴリ〜Phase の選択は保存されずに消える。
  MISSING_ACTOR_CHECK:
    '領域チェックが1つも入っていません。紐付ける領域にチェックを入れてください。',

  // 領域チェックは座標が進捗管理の組み合わせと一致して初めて有効になる。
  // 選択が途中の場合も、その組み合わせの進捗管理が無い場合もチェックできないので、
  // 「存在する組み合わせを選び直す」を一律で案内する。
  NO_LINKABLE_COORDINATE:
    '進捗管理にない紐付けです。'
    + '存在するカテゴリ〜小項目（Phase）を選択してください。',

  // 進捗管理から成果物を入力するときの検証（DeliverableSetEditor）
  NO_DELIVERABLE_CONFLICT:
    `同じ領域に「${NO_DELIVERABLE_LABEL}」と成果物は同時に登録できません`,

  DELIVERABLE_URL_REQUIRED: '成果物名を入力する場合、成果物保管URLは必須です',

  DELIVERABLE_PRODUCT_REQUIRED: '成果物保管URLを入力する場合、成果物名は必須です',
};
